import { useParams } from '@ksyos/router';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import type { IProcessActivity } from '../../../../../../common/interfaces/IProcessActivity';
import type { IOsasLifeStyleFormCustomControlDataWithPage } from '../../../../../../common/validation/customControls/osasFlex';
import type { IReduxState } from '../../../../../configureStore';
import { getProcessActivities } from '../../../../../services/api/processesApiService';
import { Main } from '../../../../elements/molecules/main/Main';
import { ProgressBar } from '../../../../elements/molecules/progressBar/ProgressBar';
import { Header } from '../../../../elements/organisms/header/Header';
import { PageWrapper } from '../../../../elements/organisms/pageWrapper/PageWrapper';
import { LifestyleQuestionnaireForm } from './LifeStyleQuestionnaireForm';
import { LifestyleQuestionnaireIntro } from './LifestyleQuestionnaireIntro';

export function LifestyleQuestionnaire() {
    const params = useParams();
    const [showIntro, setShowIntro] = useState(true);
    const [activityData, setActivityData] = useState<IOsasLifeStyleFormCustomControlDataWithPage>({
        alcoholStoppedSince: null,
        daysAWeek: null,
        drugUseStoppedSince: null,
        glassesADay: null,
        isAlcoholUser: null,
        isDrugUser: null,
        isDrugUserRemark: null,
        isSmoker: null,
        isSmokerRemark: null,
        lengthInCm: null,
        packsADaySmoked: null,
        page: 0,
        smokingStoppedSince: null,
        weightInKg: null,
        yearsSmoked: null,
    });
    const [progress, setProgress] = useState(0);
    const action = useSelector((state: IReduxState) =>
        state.authentication.actions?.find((item) => item.id === params.actionId)
    );
    const serviceActivityId = action?.activities.find(
        (activity) => activity.customControlCode === 'OSASLifestyleForm'
    )?.id;

    useEffect(() => {
        loadProcessActivity();
    }, [serviceActivityId]);

    useEffect(() => {
        setShowIntro(activityData.page === 0);
        setProgress((activityData.page / 4) * 100);
    }, [activityData]);

    if (!action || !serviceActivityId) {
        return null;
    }

    return (
        <PageWrapper fullHeight>
            <Header
                backButtonText=" "
                backUrl="/osas/questionnaires/"
                hasBackbutton
            />

            <ProgressBar progress={progress}></ProgressBar>
            <Main>
                <>
                    {showIntro && <LifestyleQuestionnaireIntro onClick={() => setShowIntro(false)} />}
                    {!showIntro && (
                        <LifestyleQuestionnaireForm
                            action={action}
                            activityData={activityData}
                            onSave={loadProcessActivity}
                            serviceActivityId={serviceActivityId}
                        />
                    )}
                </>
            </Main>
        </PageWrapper>
    );

    async function loadProcessActivity() {
        const processActivity = (await getProcessActivities()).items.find(
            (item: IProcessActivity) => item.serviceActivityId === serviceActivityId
        ) as IProcessActivity<IOsasLifeStyleFormCustomControlDataWithPage> | undefined;

        if (processActivity) {
            setActivityData(processActivity.customControlData);
        }
    }
}
